import { getEligiblePlan, toggleEligiblePlanBanner } from 'Api/subscriptionApi'
import UpgradableSubscriptionState from 'Types/_Store/UpgradableSubscription'

const state: UpgradableSubscriptionState = {
    requesting: {
        success: false,
        loading: false,
    },
    requirements: {
        isUpgradable: false,
        currentPlan: '',
        eligiblePlan: '',
        visibilityBenefit: '',
        creditBenefit: '',
        priorityBenefit: ''
    },
    bannerClosed: false,
    eligiblePlanId: 0,
    buttonSubscriptionPlan: ''
}

const mutations = {
  set_request_success(state, status) {
    state.requesting.success = status
  },

  set_request_loading(state, status) {
    state.requesting.loading = status
  },

  set_request_failure(state, status) {
    state.requesting.loading = status
  },

  set_banner_closed(state, status) {
    state.bannerClosed = status
  },

  set_elible_plan_id(state, id) {
    state.eligiblePlanId = id
  },

  set_button_subscription_plan(state, buttonSubscriptionPlan) {
    state.buttonSubscriptionPlan = buttonSubscriptionPlan
  },

  set_upgrade_requirements(state, requirements) {
    state.requirements = requirements
  },
}

const actions = {
    async getUpgradable({ commit }) {
        commit('set_request_loading', true)

        try {
            const { data } = await getEligiblePlan()

            commit('set_upgrade_requirements', data)
            commit('set_elible_plan_id', data.eligiblePlanId)
            commit('set_banner_closed', data.bannerClosed)
            commit('set_button_subscription_plan', data.buttonSubscriptionPlan)

            commit('set_request_success', true)
            commit('set_request_loading', false)
            return data
        } catch (err) {
            commit('request_failure', true)
            commit('set_request_loading', false)

            throw err
        }
    },
    async postToggleUpgradableBanner({ commit }) {
        commit('set_banner_closed', true)
        try {
          const data = await toggleEligiblePlanBanner()
          commit('set_request_success', true)
          commit('set_request_loading', false)

          return data
        } catch (err) {
          commit('request_failure', true)
          commit('set_request_loading', false)

          throw err
        }
      },
}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}